<script lang="ts" setup>
import { useClaims } from '@auth/useClaims';
import { useFieldValue, useForm } from 'vee-validate';
import type { CrmAdviseursGetAdviseursDto as Adviseur } from '@services/crm-internal/api';
import AdviseurSelectie from '../AdviseurSelectie/AdviseurSelectie.vue';
import AdviseurInstellingen from './AdviseurInstellingen/AdviseurInstellingen.vue';
import GebruikerInstellingen from './GebruikerInstellingen/GebruikerInstellingen.vue';

interface OfferteDefaultsFormValues {
  adviseur?: Adviseur;
}
useForm<OfferteDefaultsFormValues>();

const claims = useClaims();
const geselecteerdeAdviseur = useFieldValue<Adviseur | undefined>('adviseur');
</script>

<template>
  <div class="flex flex-col gap-6">
    <AdviseurSelectie v-if="claims.isInternal" />
    <AdviseurInstellingen :adviseur="geselecteerdeAdviseur" />
    <GebruikerInstellingen />
  </div>
</template>
